export default function FilterIcon() {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.4 3.19995C2.0775 3.19995 1.785 3.39495 1.66 3.69495C1.535 3.99495 1.605 4.33745 1.835 4.56495L6.4 9.13245V12C6.4 12.2125 6.48499 12.415 6.63499 12.565L8.235 14.165C8.465 14.395 8.8075 14.4625 9.1075 14.3375C9.4075 14.2125 9.6 13.9225 9.6 13.6V9.13245L14.165 4.56745C14.395 4.33745 14.4625 3.99495 14.3375 3.69495C14.2125 3.39495 13.9225 3.19995 13.6 3.19995H2.4Z" fill="#006DA3"/>
        </svg>
    );
}